import { StoreData } from "./store.data";
import { BudgetIntervalType, BudgetSpreadType } from "../types/budget.types";
import { CurrencyType } from "../types/location-currency.types";

export type BudgetModelVersion = 0;
/** Represents the store model for a budget */
export interface BudgetStoreModel extends StoreData {
  /**  **Version Number** **/
  v: BudgetModelVersion;

  nm: string; // name
  am: number; // amount
  cur?: CurrencyType | null; // currency the amount was entered in
  int: BudgetIntervalType; // interval
  sdt: Date; // startDate
  edt: Date; // endDate
  spd: BudgetSpreadType; // spread
  stp: number; // startingPreference
  ctId: string[]; // categoriesLink
}

/** Default values for the budget store model */
export const DefaultBudgetStoreModel: BudgetStoreModel = {
  v: 0,
  nm: "",
  am: 0,
  cur: null,
  int: "monthly",
  sdt: null,
  edt: null,
  spd: "continuous",
  stp: 1,
  ctId: [],
  id: "",
  dc: "",
  dm: "",
  vid: "",
};
